// extracted by mini-css-extract-plugin
export default {"button":"GenerateButton_button__WvTeQ","triangle":"GenerateButton_triangle__Cfyo+"};